import axios from "axios";

export async function get(url, token = null) {
  const config = {
    withCredentials: true,
    sameSite: "Strict",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none'",
    secure: true,
    httpOnly: true,
  };

  config.headers = token ? { Authorization: `Bearer ${token}` } : {};

  return await axios
    .get(`${url}`, config)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
      // throw new Error("Error in response - " + res);
    })
    .catch((err) => {
      throw err;
    });
}

export async function post(url, data = null) {
  const config = {
    withCredentials: true,
    sameSite: "Strict",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none'",
  };
  return await axios
    .post(`${url}`, data, config)
    .then((res) => {
      if (res?.status === 200) {
        return res?.data;
      }
      // throw new Error("Error in response - " + res);
    })
    .catch((err) => {
      throw err;
    });
}

export async function postWithAuthToken(url, data = null, token) {
  const config = {
    withCredentials: true,
    sameSite: "Strict",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none'",
    headers: { Authorization: `Bearer ${token}` },
  };
  return await axios
    .post(`${url}`, data, config)
    .then((res) => {
      if (res?.status === 200) {
        return res?.data;
      }
      // throw new Error("Error in response - " + res);
    })
    .catch((err) => {
      throw err;
    });
}

export async function postSignOut(url, data = null) {
  const config = {
    withCredentials: true,
    sameSite: "Strict",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none'",
  };
  return await axios
    .post(`${url}`, data, config)
}

export async function getListCrossRegion(url, data) {
  if (process.env.REACT_APP_MULTI_REGION_ALLOW === 'true') {
  const axiosResponse = await Promise.allSettled([
    process.env.REACT_APP_API_URL_REG_US && axios.post(
      `${process.env.REACT_APP_API_URL_REG_US}WebApi/Invoke`,
      {
        ActionVerb: "GET",
        ControllerName: data.email ? "Engagement" : "DecarbLibrary",
        ActionName: url,
        QueryString: data.email ? "CreatedBy=" + data.email : "",
        Data: "",
      },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${data.tokenUS}`,
        },
      }
    ),
    process.env.REACT_APP_API_URL_REG_APAC && axios.post(
      `${process.env.REACT_APP_API_URL_REG_APAC}WebApi/Invoke`,
      {
        ActionVerb: "GET",
        ControllerName: data.email ? "Engagement" : "DecarbLibrary",
        ActionName: url,
        QueryString: data.email ? "CreatedBy=" + data.email : "",
        Data: "",
      },
      {
        withCredentials: true,
        // baseURL: request.baseUrl,
        headers: {
          Authorization: `Bearer ${data.tokenAPAC}`,
        },
      }
    ),

    process.env.REACT_APP_API_URL_REG_EU && axios.post(
      `${process.env.REACT_APP_API_URL_REG_EU}WebApi/Invoke`,
      {
        ActionVerb: "GET",
        ControllerName: data.email ? "Engagement" : "DecarbLibrary",
        ActionName: url,
        QueryString: data.email ? "CreatedBy=" + data.email : "",
        Data: "",
      },
      {
        withCredentials: true,
        // baseURL: request.baseUrl,
        headers: {
          Authorization: `Bearer ${data.tokenEU}`,
        },
      }
    ),
  ]);

  let response = [];
  let mergedResponse = [];
  let externalUser = null;
  const validData = axiosResponse.map((res) => {
    if (res.status === "fulfilled") {
      return res.value.data;
    }

    if (res.status === "rejected") {
      console.error("Error in response", res);
    }
  });

  if (validData && validData.length) {
    // externalUser = validData?.[0]?.externalUserFlag;
    // if (validData[0]) {
    //   externalUser = validData[0].externalUserFlag;
    // } else if (validData[1]) {
    //   externalUser = validData[1].externalUserFlag;
    // } else if (validData[2]) {
    //   externalUser = validData[2].externalUserFlag;
    // }
    externalUser = validData.some(
      item => item?.externalUserFlag === 1
    );
    response = validData.flat(1).filter((x) => x);
  }

  response.map((item) => {
    mergedResponse = mergedResponse.concat(item.data);
  });

  return [mergedResponse, externalUser ? 1 : 0];
} else {
    const response =  await post(
        `/WebApi/Invoke`,
        {
          ActionVerb: "GET",
          ControllerName: data.email ? "Engagement" : "DecarbLibrary",
          ActionName: url,
          QueryString: data.email ? "CreatedBy=" + data.email : "",
          Data: "",
        },
      );
    return [ response.data, response.externalUserFlag];
}
}

export async function getListOfEngagementDetailsByUser(url, data) {
  if (process.env.REACT_APP_MULTI_REGION_ALLOW === 'true') {
    const axiosResponse = await Promise.allSettled([
      process.env.REACT_APP_API_URL_REG_US && axios.post(
        `${process.env.REACT_APP_API_URL_REG_US}WebApi/Invoke`,
        {
          ActionVerb: "GET",
          ControllerName: "Engagement",
          ActionName: url,
          QueryString: 'username=' + data?.user,
          Data: "",
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${data.tokenUS}`,
          },
        }
      ),
      process.env.REACT_APP_API_URL_REG_APAC && axios.post(
        `${process.env.REACT_APP_API_URL_REG_APAC}WebApi/Invoke`,
        {
          ActionVerb: "GET",
          ControllerName: "Engagement",
          ActionName: url,
          QueryString: 'username=' + data?.user,
          Data: "",
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${data.tokenAPAC}`,
          },
        }
      ),

      process.env.REACT_APP_API_URL_REG_EU && axios.post(
        `${process.env.REACT_APP_API_URL_REG_EU}WebApi/Invoke`,
        {
          ActionVerb: "GET",
          ControllerName: "Engagement",
          ActionName: url,
          QueryString: 'username=' + data?.user,
          Data: "",
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${data.tokenEU}`,
          },
        }
      ),
    ]);

    let response = [];
    let mergedResponse = [];
    const validData = axiosResponse.map((res) => {
      if (res.status === "fulfilled") {
        return res?.value?.data;
      }
      if (res.status === "rejected") {
        console.error("Error in response", res);
      }
    });
    console.log('validData---', validData);
    if (validData && validData.length) {
      response = validData.flat(1).filter((x) => x);
    }
    console.log('response---', response);
    response.map((item) => {
      mergedResponse = mergedResponse.concat(item);
    });

    console.log('mergedResponse---', mergedResponse);
    return mergedResponse;
  } else {
    return await post(`/WebAPi/Invoke`, {
      ActionVerb: "GET",
      ControllerName: "Engagement",
      ActionName: url,
      QueryString: "username=" + data?.user,
      Data: "",
    });
  }
}
